import React from 'react';
import styles from './stats.module.css';

const WEEKDAYS = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'];

/**
 * Procura por dia da semana e hora. Mostra só as horas com movimento (da
 * primeira à última); a cor fica mais forte conforme a procura.
 * `cells`: [{ weekday: 1-7 (segunda = 1), hour: 0-23, count }]
 */
const Heatmap = ({ cells }) => {
  const list = cells || [];
  if (list.length === 0) return <div className={styles.emptyChart}>Sem atendimentos no período.</div>;

  const hours = list.map((cell) => cell.hour);
  const firstHour = Math.min(...hours);
  const lastHour = Math.max(...hours);
  const max = Math.max(...list.map((cell) => cell.count), 1);
  const byKey = {};
  list.forEach((cell) => { byKey[`${cell.weekday}-${cell.hour}`] = cell.count; });
  // Fim de semana só aparece se tiver movimento
  const weekdays = [1, 2, 3, 4, 5, 6, 7].filter((day) => day <= 5 || list.some((cell) => cell.weekday === day));
  const hourList = [];
  for (let hour = firstHour; hour <= lastHour; hour++) hourList.push(hour);

  return (
    <div className={styles.heatmap}>
      <table className={styles.heatTable}>
        <thead>
          <tr>
            <th />
            {hourList.map((hour) => <th key={hour}>{`${hour}h`}</th>)}
          </tr>
        </thead>
        <tbody>
          {weekdays.map((day) => (
            <tr key={day}>
              <th>{WEEKDAYS[day - 1]}</th>
              {hourList.map((hour) => {
                const count = byKey[`${day}-${hour}`] || 0;
                const strength = count / max;
                return (
                  <td
                    key={hour}
                    className={styles.heatCell}
                    title={`${WEEKDAYS[day - 1]} ${hour}h: ${count}`}
                    style={{
                      background: count ? `rgba(90, 128, 251, ${0.12 + strength * 0.78})` : '#F5F7FB',
                      color: strength > 0.55 ? '#FFFFFF' : '#4A5568',
                    }}
                  >
                    {count || ''}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Heatmap;
